import { CustomFieldLabelPane as PtCustomFieldLabelPane, Toast } from 'patsnap-biz';
import _ from 'lodash';
import { saveTaskCustomFieldValueApi } from '../../../../../components/apis/workspace_api/task';
import FieldService from '../../services/field-service';
import { getRouteNameList } from '../../router';
import { RavenInsertMeta } from 'library-@/services/sentry';
import { updateCustomFieldSortApi, confirmAiFieldApi } from '../../../../../components/apis/workspace_api/custom_field';
import { FieldEditorService } from '../../../../../components/components/fieldEditor';

export default class CustomFieldController extends PtCustomFieldLabelPane.CustomFieldLabelController {
    spaceType = '';

    taskId = '';

    spaceId = '';

    folderId = '';

    isOwner = '';

    customFieldsDisplay = false;

    // localStorage key for tab expand status
    get tabExpandStatusStorageKey() {
        return 'patent_view_custom_field_tab_expand_status';
    }

    // 保存 tabExpandStatus 到 localStorage
    saveTabExpandStatusToStorage() {
        try {
            localStorage.setItem(this.tabExpandStatusStorageKey, JSON.stringify(this.tabExpandStatus));
        } catch (error) {
            console.warn('Failed to save tab expand status to localStorage:', error);
        }
    }

    // 从 localStorage 读取 tabExpandStatus
    loadTabExpandStatusFromStorage() {
        try {
            const saved = localStorage.getItem(this.tabExpandStatusStorageKey);
            if (saved) {
                const parsedStatus = JSON.parse(saved);
                // 合并保存的状态到当前状态
                Object.assign(this.tabExpandStatus, parsedStatus);
                return true;
            }
        } catch (error) {
            console.warn('Failed to load tab expand status from localStorage:', error);
        }
        return false;
    }


    /* ------------ 自定义支持投票的popover开始 ------------ */
    customCustomFieldEditorCacheMap = {};


    get customCustomFieldEditorComponent() {
        return (this.folderId && this.spaceId && this.patentId) ? FieldEditorService.Dialog : undefined;
    }

    getCustomCustomFieldEditorService(field) {
        const id = field.field_id;
        if (this.folderId && this.spaceId && this.patentId) {
            if (!this.customCustomFieldEditorCacheMap[id]) {
                const serv = new FieldEditorService();
                serv.i18n = this.vm.$i18n;
                this.customCustomFieldEditorCacheMap[id] = serv;
            }
            return this.customCustomFieldEditorCacheMap[id];
        }
        return undefined;
    }

    openCustomCustomFieldEditor({ field, value }) {
        return this.getCustomCustomFieldEditorService(field).open({
            field,
            value,
            row: {
                PATENT_ID: this.patentId,
            },
            folderId: this.folderId,
            spaceId: this.spaceId,
        });
    }

    /* ------------ 自定义支持投票的popover结束 ------------ */

    constructor({ vm, workspaceProductDomain, spaceType, taskId, spaceId, folderId, fields, isOwner, patentId, pinnedFields, customFieldsDisplay, spaceScopeFieldTip }) {
        super({ vm, workspaceProductDomain });
        // self  shared public  navigation 导航库跳转过来展示的是自己的自定义字段
        this.spaceType = spaceId === '' && folderId === '' ? 'self' : spaceType;
        this.taskId = taskId;
        this.spaceId = spaceId;
        this.folderId = folderId;
        // 所有的自定义字段
        this.fields = fields;
        this.isOwner = isOwner;
        this.patentId = patentId;
        this.pinFieldsKeys = pinnedFields;
        this.customFieldsDisplay = customFieldsDisplay;
        this.spaceScopeFieldTip = spaceScopeFieldTip;
        const fieldValueMap = {};
        _.forEach(fields, ({ field_id, field_value }) => {
            fieldValueMap[field_id] = field_value;
        });
        //设置标引值
        this.updateFieldValueMap(fieldValueMap);

        // 尝试从 localStorage 恢复 tab 展开状态
        const hasRestoredFromStorage = this.loadTabExpandStatusFromStorage();

        // 如果没有从 localStorage 恢复成功，则使用默认展开的tab
        if (!hasRestoredFromStorage) {
            if (this.taskId) {
                this.tabExpandStatus['self'] = true;
            } else {
                if (this.spaceId && this.folderId) {
                    if (this.spaceType === 'navigation') {
                        // 导航库跳转过来展示的是自己的自定义字段
                        this.tabExpandStatus['self'] = true;
                    } else if (this.customFieldsDisplay) {
                        //分享的workspace 自定义字段不可见的时候，不展示分享的字段，默认展开我的自定义字段
                        this.tabExpandStatus[this.spaceType] = true;
                    } else {
                        this.tabExpandStatus['self'] = true;
                    }
                } else {
                    this.tabExpandStatus['self'] = true;
                }
            }
        }
    }

    expandAll() {
        super.expandAll();
        // 保存状态到 localStorage
        this.saveTabExpandStatusToStorage();
    }

    toggleTabExpandStatus(type) {
        super.toggleTabExpandStatus(type);
        // 保存状态到 localStorage
        this.saveTabExpandStatusToStorage();
    }

    // ws任务的不展示字段分类
    isShowFieldGroupHeader(type) {
        // 来自分享的 workspace 不展示 我的自定义字段，原来是只要非 self spaceType 的自定义字段都隐藏
        if (this.spaceType === 'shared' && type === 'self') {
            return false;
        }
        return !this.taskId;
    }

    // 生成Group无数据的提示文案;
    generateFieldGroupEmptyText(type) {
        if(this.fieldFilterString) {
            return this.vm.$t('PtCustomFieldLabelPane.filter.noFilterData');
        } else if(this.hasManageFieldPermission(type)) {
            return this.vm.$t('customFields.familyTip.noCustomField');
        }

        return this.vm.$t('customFields.familyTip.noCustomField');
    }

    toggleFieldPin = async (fieldId) => {
        // 固定->true， 取消-》false
        let is_pin = true;
        if (this.isFieldPinned(fieldId)) {
            this.unPinField(fieldId);
            is_pin = false;
        } else {
            this.pinField(fieldId);
        }
        const find = _.find(this.fields, { field_id: fieldId });
        let isCustomField = false;
        if (find) {
            isCustomField = !find.shared && !find.public_field;
        }
        await updateCustomFieldSortApi(fieldId, !isCustomField ? this.folderId : undefined, is_pin);
    };

    hasLabelFieldPermission = (field) => {
        return field.edit_value || false;
    };

    generateSpaceScopeDisableTip(field) {
        if (this.spaceType === 'shared') {
            // 来自分享的 workspace 禁用的提示，只有这一种情况
            return this.vm.$t('PtCustomFieldLabelPane.spaceScopeEditNoPermissionTip');
        }
        if (!field.public_field) {
            // 个人自定义字段禁用，只有一种情况
            return this.vm.$t('PtCustomFieldLabelPane.spaceScopeEditTip');
        }
        // 企业自定义字段禁用的提示
        if (this.fieldLabelScopeIsSpace(field)) {
            // 是非全局自定义字段, 有两种情况
            return this.spaceType === 'public' ? this.vm.$t('PtCustomFieldLabelPane.spaceScopeEditNoPermissionTip') : this.vm.$t('PtCustomFieldLabelPane.spaceScopeEditTip');
        }
        // 企业全局字段禁用的提示
        return this.vm.$t('PtCustomFieldLabelPane.spaceScopeEditNoPermissionTip');
    }

    showSpaceScopeDisableTip = (field) => {
        return !this.hasLabelFieldPermission(field);
    };

    // 如果为false，则不显示该类型的字段;
    // 来自srp、我的 workspace 展示我的自定义字段、企业自定义字段
    // 来自分享的 workspace 展示被分享的自定义字段、企业自定义字段
    // 来自企业的workspace的 展示企业的定义字段、我的自定义字段
    isFieldMainTypeSupported = (type) => {
        if (this.spaceId && this.folderId) {
            // 来自 workspace
            if (this.spaceType === 'shared' && (type === 'shared' || type === 'public') && this.customFieldsDisplay) {
                return true;
            }
            if (this.spaceType === 'public' && (type === 'public' || type === 'self') && this.customFieldsDisplay) {
                return true;
            }
            if (this.spaceType === 'self' && (type === 'public' || type === 'self') && this.customFieldsDisplay) {
                return true;
            }
            return false;
        } else {
            // 来自 srp
            if (type === 'public' || type === 'self') {
                return true;
            }
        }
        return false;
    };

    // 是否支持置顶字段
    isPinSupported = () => {
        if (this.taskId || this.vm.isFamilySearch || (this.spaceId && this.folderId)) {
            return false;
        }
        return true;
    };

    // 是否有创建字段的权限，如果有，无数据时会显示创建按钮;
    // 来自srp、我的workspace 如果没有数据 有创建按钮
    // 来自分享的workspace 如果没有数据 没有创建按钮
    // 来自企业的workspace的 如果没有数据，是企业的admin才有创建按钮
    hasManageFieldPermission = (type) => {
        if (type === 'self') {
            return true;
        }
        if (type === 'shared') {
            return false;
        }
        if (type === 'public' && this.isOwner === 'OWNER') {
            return true;
        }
        return false;
    };

    // 标引值请求发送方法
    onLabelFieldSubmit = ({ fieldId, value, field }) => {
        // eslint-disable-next-line
        return new Promise(async (resolve, reject) => {
            let find = _.find(this.fields, { field_id: fieldId });
            let params = {
                field_id: fieldId,
                field_value: value,
                field_type: _.get(find, 'field_type', ''),
                shared: _.get(find, 'shared'),
            };
            // 同族库下是否对代表专利标引
            if (this.vm.isFamilySearch) {
                params.ignore_family_edit = !this.vm.isFamilyMainPatent;
            }
            try {
                let needFolderId = !!this.folderId;
                if (this.spaceType === 'public' && !field.public_field) {
                    needFolderId = false;
                } else if ((this.spaceType === 'self' || this.spaceType === 'shared') && field.public_field) {
                    needFolderId = false;
                }
                if (needFolderId) params.folder_id = this.folderId;
                if (this.taskId) {
                    await saveTaskCustomFieldValueApi({
                        ...params,
                        patent_id: this.patentId,
                        task_id: this.taskId,
                        is_shared: params.shared,
                    });
                } else {
                    this.fieldService = new FieldService(this.patentId);
                    await this.fieldService.saveFieldValue(params);
                }
                let findIndex = _.findIndex(this.fields, { field_id: fieldId });
                if (findIndex > -1) {
                    this.vm.$set(this.fields[findIndex], 'field_value', value);
                }

                if (field.show_ai) {
                    await confirmAiFieldApi({
                        folder_id: this.folderId,
                        select_mode: 'INCLUDE',
                        patent_ids: [this.patentId],
                        refiner: {},
                        ai_field_id: field.field_id,
                    });
                    field.show_ai = false;
                    RavenInsertMeta('Custom field', 'click_ai_edit', {
                        other_param: 'Patent View',
                    });
                }
                RavenInsertMeta('Custom field', 'Save Custom Field', {
                    source: getRouteNameList(this.vm.$route),
                });
                resolve(value);
            } catch (error) {
                Toast({
                    message: error._error_msg || this.vm.$t('net.400'),
                    type: 'error',
                    showClose: true,
                });
                reject();
            }
        });
    };

    // 点击AI Check Icon操作
    onClickAICheckIcon = (field) => {
        return confirmAiFieldApi({
            folder_id: this.folderId,
            select_mode: 'INCLUDE',
            patent_ids: [this.patentId],
            refiner: {},
            ai_field_id: field.field_id,
        }).then(() => {
            field.show_ai = false;
            RavenInsertMeta('Custom field', 'click_ai_icon', {
                other_param: 'Patent View',
            });
        }).catch (error => {
            Toast({
                message: error._error_msg || this.vm.$t('net.400'),
                type: 'error',
                showClose: true,
            });
        });
    };

}
